import { useMemo } from "react";

import type { Operator } from "@skilitics/judy";

/**
 * The operator choices a subtype's form offers, from the definition's own list.
 *
 * A design authored before a list narrowed may hold an operator no longer
 * offered. Keep it visible so the author sees what is stored and can change it,
 * rather than facing an empty select over a condition that still evaluates.
 */
export const useOperatorOptions = (operators: readonly Operator[], stored: Operator | "" | undefined) =>
  useMemo(() => {
    const offered = stored && !operators.includes(stored) ? [...operators, stored] : operators;
    return offered.map((value) => ({ value, label: value }));
  }, [operators, stored]);
